import moment from 'moment'
// import ft from '../featureToggle'

export default {
  getPromoCodes (VueApp, conId, callback) {
    let promoCodes = VueApp.$store.state.consumer.promoCodes
    let pageSize = promoCodes.perPage
    let page = promoCodes.currentPage

    VueApp.$sdk.get('/consumer/' + conId + '/promocodes', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('consumer/setPromoCodesCurrentPage', page + 1)

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setPromoCodesIsMax', true)
        }

        if (res.list.length) {
          let promoCode = res.list
          for (let i = 0; i < res.list.length; i++) {
            let redeemDate = moment(promoCode[i].redeemedDate, 'YYYY-MM-DD HH:mm:ss')
            VueApp.$store.commit('consumer/addPromoCodes', {
              date: redeemDate.format('MM/DD/YYYY HH:mm:ss'),
              code: promoCode[i].promoCode,
              value: promoCode[i].amount,
              redeemedAmount: promoCode[i].redeemedAmount,
              type: promoCode[i].type,
              // expires: redeemDate.add(promoCode[i].redeemedValidDays, 'days').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, true))
              expires: redeemDate.add(promoCode[i].redeemedValidDays, 'days').format('MM/DD/YYYY HH:mm:ss')
            })
          }
        }
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/promo-codes.js